import { API_PATH } from '@/types/shared';
import { useRequest } from './useRequest';
import { useRef } from '@max/max';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
export var BIZ_TYPE;
(function (BIZ_TYPE) {
    BIZ_TYPE["HOTEL"] = "hotel";
    BIZ_TYPE["TRAVEL"] = "travel";
})(BIZ_TYPE || (BIZ_TYPE = {}));
export var INTENTION_SCENE;
(function (INTENTION_SCENE) {
    INTENTION_SCENE[INTENTION_SCENE["HOTEL_TRAVEL_INTENTION"] = 1] = "HOTEL_TRAVEL_INTENTION";
})(INTENTION_SCENE || (INTENTION_SCENE = {}));
var INTENTION_TAG_ID;
(function (INTENTION_TAG_ID) {
    INTENTION_TAG_ID[INTENTION_TAG_ID["HOTEL_TRAVEL_INTENTION"] = 5] = "HOTEL_TRAVEL_INTENTION";
})(INTENTION_TAG_ID || (INTENTION_TAG_ID = {}));
var ScoreType;
(function (ScoreType) {
    ScoreType["HotelScore"] = "1";
    ScoreType["TicketScore"] = "2";
    ScoreType["VacationScore"] = "3";
    ScoreType["TrafficScore"] = "4";
})(ScoreType || (ScoreType = {}));
var TravelServiceType;
(function (TravelServiceType) {
    TravelServiceType["Hotel"] = "1";
    // 酒店
    TravelServiceType["Flight"] = "2";
    // 机票
    TravelServiceType["Train"] = "3";
    // 火车票
    TravelServiceType["Ticket"] = "5";
    // 门票
    TravelServiceType["Vacation"] = "6"; // 度假
})(TravelServiceType || (TravelServiceType = {}));
// ScoreType 到 TravelServiceType 的映射
const SCORE_TYPE_TO_TRAVEL_SERVICE_TYPE_MAP = {
    [ScoreType.HotelScore]: [TravelServiceType.Hotel],
    [ScoreType.TicketScore]: [TravelServiceType.Ticket],
    [ScoreType.VacationScore]: [TravelServiceType.Vacation],
    [ScoreType.TrafficScore]: [TravelServiceType.Flight, TravelServiceType.Train]
};
export const useIntentionData = () => {
    const { request } = useRequest(API_PATH.QUERY_INTENTION, {
        showLoading: false
    });
    const maxIntentionBiz = useRef(ScoreType.HotelScore);
    const ctx = useMonitorEngineContext();
    const queryIntentionInfo = async (params = {}) => {
        try {
            Object.assign(params, {
                scene: INTENTION_SCENE.HOTEL_TRAVEL_INTENTION,
                tagIds: [INTENTION_TAG_ID.HOTEL_TRAVEL_INTENTION]
            });
            const res = await request(params);
            if (res?.uni_status_code) {
                ctx?._raptorReport?.monitorReportBizFailed?.();
                return null;
            }
            if (Array.isArray(res?.tags) && res?.tags?.length > 0) {
                ctx?._raptorReport?.monitorReportBizSuccess?.();
                const tagInfoMap = res?.tags.find(tag => tag?.tagId === INTENTION_TAG_ID.HOTEL_TRAVEL_INTENTION)?.tagInfoMap || {};
                // 找到最大的意向度业务线
                let maxBiz = ScoreType.HotelScore;
                let maxScore = 0;
                Object.entries(tagInfoMap).forEach(([scoreType, score]) => {
                    if (typeof score === 'number' && score > maxScore) {
                        maxScore = score;
                        maxBiz = scoreType;
                    }
                });
                maxIntentionBiz.current = maxBiz;
                // 将 ScoreType 转换为 TravelServiceType，保持意向度一致
                const convertedTagInfoMap = {};
                Object.entries(tagInfoMap).forEach(([scoreType, score]) => {
                    const travelServiceTypes = SCORE_TYPE_TO_TRAVEL_SERVICE_TYPE_MAP[scoreType];
                    if (travelServiceTypes && typeof score === 'number') {
                        travelServiceTypes.forEach(serviceType => {
                            convertedTagInfoMap[serviceType] = score;
                        });
                    }
                });
                return convertedTagInfoMap;
            }
            else {
                ctx?._raptorReport?.monitorReportBizFailed?.();
                return {};
            }
        }
        catch (error) {
            ctx?._raptorReport?.monitorReportBizFailed?.();
            return {};
        }
    };
    return {
        queryIntentionInfo,
        maxIntentionBiz
    };
};
